import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export function usePublicConfig() {
  return useQuery({
    queryKey: ["config", "public"],
    queryFn: api.publicConfig,
    staleTime: Infinity,
  });
}
